import { Injectable } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl, ValidatorFn } from '@angular/forms';
import { RetornoValidacaoModel } from './model/retorno-validacao.model';
import { ToasterUtilService } from './toaster-util.service';
import { StatusNota } from './enum/status-nota.enum';
declare var $: any;
declare var numeral: any;

@Injectable()
export class UtilService {

  public static onModal: Boolean = false;

  constructor() { }

  static limpaFormulario(form:FormGroup){
        form.reset();
  }

  static empty(value : any){
    return value == undefined || value == null || value.length == 0 || value == '';
  }

  static formatarCnpj(value : string){
    return !this.empty(value) ? value.replace(/\D/g, '').replace(/^(\d{2})(\d{3})?(\d{3})?(\d{4})?(\d{2})?/, "$1.$2.$3/$4-$5") : '';
  }

  static getIdsSelect2(data) : string[]{
    let retorno: Array<string> = null;
    if(data != undefined && data != null && data.length > 0){
      retorno = [];
      for (var i = 0; i < data.length; i++) {
        retorno.push(String(data[i].id));
      }
    }
    return retorno;
  }

  static leftPad(str: string, len: number, ch='.'): string {
    len = len - str.length + 1;
    return len > 0 ?
      new Array(len).join(ch) + str : str;
  }

  static numberNotNull(value : number){
    if(this.empty(value)){
      return 0.0;
    }

    return value;
  }

  static stringNotNull(value : string) : string {
    return this.empty(value) ? '' : value;
  }

  static stringSomenteNumero(value : string) : string {
    return this.stringNotNull(value).replace(/[^0-9]/g,'');
  }

  static booleanNotNull(value : Boolean) : Boolean {
    return value == undefined || value == null ? false : value;
  }

  static listStringToListNumber(list : Array<string>) : Array<number> {
    let retorno: Array<number> = null;

    if(!this.empty(list)){
      retorno = [];
      for(let item of list){
        retorno.push(parseInt(item));
      }
    }

    return retorno;
  }

  listStringToListNumber

  static validatedToZero(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} => {
      if (control.value != undefined && control.value != null) {
        if (!isNaN(control.value)) {
          if (control.value == 0) {
              return {'validatedToZero': true };
          }
        }
      }
      return null;
    }
  };

  static formataTelefone(value: string): string {
      let numbers = value && value.replace(/[^0-9]/g,"");
      let matches = numbers && numbers.match(/^(\d{2})(\d?\d{4})(\d{4})$/);
      if(matches) {
        return "(" + matches[1] + ") " + matches[2] + "-" + matches[3];
      }
      return value;
  }

  static parseData(data: any): Date {
    if(data == null || data == undefined || data == '') {
      return null;
    }
    let dia   = parseInt(data.date.day);
    let mes  = parseInt(data.date.month);
    let ano   = parseInt(data.date.year);
    let date = new Date(ano, mes-1, dia);
    return date;
  }

  static parseDatePicker(data: Date) {
    let valor = {
      date: {
        year: data.getFullYear(),
        month: data.getMonth() + 1,
        day: data.getDate()
      }
    }
    return valor;
  }

  static parseHora(data: Date) {
    let valor = '';
    if(!this.empty(data)) {
      data = new Date(data);
      valor = (data.getHours() < 10 ? '0' + data.getHours() : data.getHours()) + ':' + (data.getMinutes() < 10 ? '0' + data.getMinutes() : data.getMinutes());
    }
    return valor;
  }

  static isImagem(file){
    return file.substring(0,5) == 'image';
  }

  static round(valor){
    return Math.round( valor * 100 ) / 100;
  }

  static retornaTexto(id: number, array: Array<any>): string {
    let retorno: string = '';
    if(array != undefined && array != null && array.length > 0) {
      array.forEach((el) => {
        if (el.id == id) {
          if (el.text != undefined && el.text != null) {
            retorno = el.text;
          } else if (el.codigo != undefined && el.codigo != null){
            retorno = el.codigo;
          } else if (el.descricao != undefined && el.descricao != null){
            retorno = el.descricao;
          }
        }
      });
    }
    return retorno;
  }

  static disabledAllFields(form : FormGroup){
    for (let field in form.controls) {
      form.get(field).disable();
    }
  }

  static enabledAllFields(form : FormGroup){
    for (let field in form.controls) {
      form.get(field).enable();
    }
  }

  static numberFormatOtica(value : number) : string{
    return new numeral(value).format(value > 0 ? '+0,0.00' : '0,0.00');
  }

  static stringToFloat(value: any) : number{

    if($.trim(value) === ""){
      value =  0;
    }else{
        value = $.ats._replaceAll(typeof(value) === 'number' ? value.toString() : value, ".","");
        value = $.ats._replaceAll(typeof(value) === 'number' ? value.toString() : value, ",",".");
        value = parseFloat(value);
    }

    return value;
  }

  static limparArray(arrayList: Array<any>) : void{
    if(!this.empty(arrayList)){
      while(arrayList.length > 0) {
        arrayList.pop();
      }
    }
  }

  static downloadJson(content, fileName, contentType) {
    var a = document.createElement("a");
    var file = new Blob([content], {type: contentType});
    a.href = URL.createObjectURL(file);
    a.download = fileName;
    a.click();
  }

  static getUrl() : string  {
    return './api';
    // return 'http://localhost:8080/atscloud/api';
  }

  static getUrlAutenticacao() : string  {
    return './';
    // return 'http://localhost:8080/atscloud/';
  }

  static getStatusNotaLabels(status : number) : StatusNota  {
    let retorno: StatusNota = null;

    switch (status) {
      case 1:
        retorno = StatusNota.NOTA_AUTORIZADA;
        break;
      case 2:
        retorno = StatusNota.NOTA_EMITIDA_EM_CONTIGENCIA;
        break;
      case 3:
        retorno = StatusNota.NOTA_REJEITADA;
        break;
      case 4:
        retorno = StatusNota.NOTA_DENEGADA;
        break;
      case 5:
        retorno = StatusNota.NOTA_INEXISTENTE;
        break;
      case 6:
        retorno = StatusNota.NOTA_CANCELADA;
        break;

      default:
        break;
    }

    return retorno;
  }

  static processaRetornoValidator(retorno: RetornoValidacaoModel, toasterUtil: ToasterUtilService) : void  {
    if(!UtilService.empty(retorno) && !UtilService.empty(retorno.mensagens)){
      for (let index = 0; index < retorno.mensagens.length; index++) {
        switch (retorno.mensagens[index].tipoAlerta) {
          case 'alert':
            toasterUtil.alerta(retorno.mensagens[index].mensagem);
            break;
            case 'error':
            toasterUtil.erro(retorno.mensagens[index].mensagem);
            break;
            case 'warning':
            toasterUtil.alerta(retorno.mensagens[index].mensagem);
            break;
            case 'info':
            toasterUtil.info(retorno.mensagens[index].mensagem);
            break;
            case 'success':
            toasterUtil.sucesso(retorno.mensagens[index].mensagem);
            break;
            default:
            break;
        }
      }
    }
  }

}





// WEBPACK FOOTER //
// ./src/app/util/util.service.ts